module.exports = __webpack_public_path__ + "static/media/EyeWhite.1704aa23.svg";